export const singleAvailabilityResetPayload = ({ shift_date, service_id }) => ({
  items: [{
    shift_date,
    service_id,
    state: 'NON_INDICATA',
  }],
});